export enum PaymentDetailsIds {
  AddNewCard = 'payment-details__add-new-card'
}
